import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Order } from '../orders-new/models/order.dto';
import { toVoid } from '../../../utils/void';

@Injectable({ providedIn: 'root' })
export class ProductionPlannerProvider {
  constructor(private http: HttpClient) {}

  getOrders(): Observable<Order[]> {
    const url = `/api/production-orders`;
    return this.http.get<Order[]>(url);
  }

  planOrder(orderId: number, plannedStartDate: string | null, plannedEndDate: string | null): Observable<void> {
    const url = `/api/production-orders/${orderId}/plan`;
    return this.http.patch(url, { plannedStartDate, plannedEndDate }).pipe(toVoid());
  }
}
